<div class="overlay">
  <div class="center">
    <mat-progress-spinner
      class="example-margin"
      value=50
      mode="indeterminate"
      color="primary">
    </mat-progress-spinner>
  </div>
</div>
